<template>
    <div class="proyeccion-page">
        <TablaPagos />
        <!-- <div v-else>Trabando en los refinanciamientos 🤖</div> -->
    </div>

</template>

<script>
import '@vuepic/vue-datepicker/dist/main.css'

import TablaPagos from './Tabla-Proyeccion.vue';

export default {
    components: {
        TablaPagos
    },
    data() {
        const today = new Date();
        today.setHours(0, 0, 0, 0); // Establece las horas, minutos, segundos y milisegundos en 0
        return {
            date: [today, today], // Inicializa la fecha de hoy como la primera fecha del rango
            ready: false,
            pagos: [],
            pagoOption: true,
        };

    },
    methods: {

    }

}
</script>

<style scoped>
.proyeccion-page {
    width: 100%;
}

.btn-check:checked+.btn-outline-secondary,
.btn-check:active+.btn-outline-secondary,
.btn-outline-secondary:active,
.btn-outline-secondary.active,
.btn-outline-secondary.dropdown-toggle.show {
    color: #fff;

}
</style>
